import React, { useMemo } from 'react';

import { sanitizeRichHtml } from 'helper/richHtml';

/**
 * Renderiza HTML autorado por admin (editor Quill, texto colado) sanitizado e com as cores
 * neutras do texto colado removidas — ver `helper/richHtml`.
 *
 * Boundary de segurança: a regra security.md exige sanitização em todo dangerouslySetInnerHTML.
 * Aqui centralizamos o sanitize + o `react/no-danger`. A className (ex.: `ql-editor`) preserva
 * a formatação visual do Quill.
 */
export default function RichHtml({
  html,
  className,
}: {
  html: string;
  className?: string;
}) {
  // Objeto memorizado, e não `{{ __html }}` novo a cada render: o React 19 reaplica o `innerHTML`
  // quando a referência do objeto muda (não compara o `__html`), o que troca os nós do texto e
  // desfaz a seleção de quem está lendo ou copiando.
  const markup = useMemo(() => ({ __html: sanitizeRichHtml(html) }), [html]);

  return (
    <div
      className={className}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={markup}
    />
  );
}
